export default __webpack_public_path__ + "static/media/baseline-battery_alert-24px.7ff90718.svg";